export default __webpack_public_path__ + "static/media/image-bot-unlocked.c5fc428f.jpg";